module.exports = __webpack_public_path__ + "assets/path-2-2aee9814c6d880c2de1d78f2536a0d6e.svg";